import React from 'react';
import ModulePage from '../components/ModulePage';
import { moduleLandingData } from '../mock/moduleLandingData';

export default function InventoryPage() {
  return <ModulePage data={moduleLandingData.inventory} />;
}
